import { injectGlobal } from 'emotion'

injectGlobal`
  * {
    box-sizing: border-box;
  }
  body {
    font-family: 'Poppins', sans-serif;
    margin: 0;
  }

  a {
    color: #5284ff;
    text-decoration: none;
    transition: 0.2s;

    // &:hover {
    //   color: #2C46A6;
    // }
  }
`
